import {JSX} from 'react'
import { Navigate } from 'react-router-dom'
import {isTokenExpired} from '../libs/tokenUtils'

interface Props {
  children: JSX.Element
  allowedRoles?: string[]
}

export default function ProtectedRoute({ children, allowedRoles }: Props): JSX.Element {
  const token = localStorage.getItem('token')
  const userRoleSlug = localStorage.getItem('user_role_slug')

  if (!token || isTokenExpired()) {
    return <Navigate to="/login" replace />
  }

  if (allowedRoles && !allowedRoles.includes(userRoleSlug ?? '')) {
    return <Navigate to="/not-found" replace />
  }

  return children
}
